import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import React from 'react';
import { FC, useState } from 'react';

interface DeviceDetailInputProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  requiresConfirmation?: boolean;
}

const DeviceDetailInput: FC<DeviceDetailInputProps> = ({
  label,
  value,
  onChange,
  requiresConfirmation = false,
}: DeviceDetailInputProps) => {
  const [inputValue, setInputValue] = useState(value);

  const handleCheckboxClick = (): void => {
    const newValue = inputValue === null ? '' : null;
    setInputValue(newValue);
    if (newValue === null) onChange(newValue);
  };

  return (
    <>
      {requiresConfirmation && (
        <FormControlLabel
          control={
            <Checkbox
              checked={inputValue !== null}
              sx={{ '&.Mui-checked': { color: '#00BCD4' } }}
              onChange={handleCheckboxClick}
            />
          }
          label={label}
          sx={{
            '& .MuiFormControlLabel-label': {
              fontWeight: 'bold',
            },
          }}
        />
      )}

      {!requiresConfirmation && <div className="font-bold">{label}</div>}

      {(!requiresConfirmation || inputValue !== null) && (
        <TextField
          label={requiresConfirmation ? undefined : label}
          sx={{
            //this hides the label when requiresConfirmation is true
            '& .MuiOutlinedInput-notchedOutline legend': {
              display: requiresConfirmation ? 'none' : 'inherit',
            },
          }}
          size="small"
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => setInputValue(e.target.value)}
          value={inputValue}
          onBlur={(): void => onChange(inputValue)}
        />
      )}
    </>
  );
};

export default DeviceDetailInput;
